import sharedModule from '../../shared.module';
import template from './alertNotification.component.html';
import style from './alertNotification.component.css';

export default sharedModule.component('alertNotification', {
    template,
    style,
    bindToController: true,
    bindings: {
        data: '<'
    },
    controller(alertNotificationConstants) {
        var vm = this;
        vm.notifications = {};

        var runningId = 0;
        vm.$onChanges = () => {
            if (!vm.data) {
                return;
            }

            vm.data.forEach(notification => {
                notification.$$id = runningId++;

                switch (notification.type) {
                    case alertNotificationConstants.error:
                        notification.iconClass = 'fa-exclamation-triangle';
                        break;
                    case alertNotificationConstants.info:
                        notification.iconClass = 'fa-info-circle';
                        break;
                    case alertNotificationConstants.success:
                        notification.iconClass = 'fa-check-circle';
                        break;
                    case alertNotificationConstants.warning:
                        notification.iconClass = 'fa-exclamation-circle';
                        break;
                }

                vm.notifications[notification.$$id] = notification;
            });
        };

        vm.removeNotification = notificationId =>
            delete vm.notifications[notificationId];
    }
});



// WEBPACK FOOTER //
// ./modules/shared/components/alertNotification/alertNotification.component.js